import {
  project1Laptop,
  project1Mobile,
  project2Laptop,
  project2Mobile,
  project3Laptop,
  project3Mobile,
  project4Laptop,
  project4Mobile,
  project5Laptop,
  project5Mobile,
  project6Laptop,
  project6Mobile,
} from "./projectImages";

export const projectData = [
  {
    id: 1,
    image: project1Laptop,
    transitionImage: project1Mobile,
    title: "Tech Help",
    codeLink: "https://github.com/mdmonauwarulislam/jobpulse.io",
    liveLink: "https://jobpulse-io.vercel.app/",
  },
  {
    id: 2,
    image: project2Laptop,
    transitionImage: project2Mobile,
    title: "Elysium Real Estate",
    codeLink: "https://github.com/mdmonauwarulislam/Elysium---Real-Estate",
    liveLink: "https://elysium-real-estate-f3ck.vercel.app/",
  },
  {
    id: 3,
    image: project3Laptop,
    transitionImage: project3Mobile,
    title: "E-Learning Platform",
    codeLink: "https://github.com/mdmonauwarulislam/e-learning",
    liveLink: "https://mdmonauwarulislam.github.io/e-learning/",
  },
  {
    id: 4,
    image: project4Laptop,
    transitionImage: project4Mobile,
    title: "MERN Blog Website",
    codeLink: "https://github.com/mdmonauwarulislam/mern-blog-web-app",
    liveLink: "https://mern-blog-web-app-sooty.vercel.app/",
  },
  {
    id: 5,
    image: project5Laptop,
    transitionImage: project5Mobile,
    title: "Hospital Management DashBoard",
    codeLink: "https://github.com/mdmonauwarulislam/hms-frontend.git",
    liveLink: "https://hms-frontend-nine.vercel.app/login",
  },
  {
    id: 6,
    image: project6Laptop,
    transitionImage: project6Mobile,
    title: "E Commerce Web App",
    codeLink: "https://github.com/mdmonauwarulislam/E-Commerce-Web-Application.git",
    liveLink: "https://github.com/mdmonauwarulislam/E-Commerce-Web-Application.git",
  },
];
